<template>
  <div
    id="select"
    style="background: #dfdfdf; min-height: 100vh; padding-bottom: 10rem"
  >
    <div style="display: flex; flex-direction: row; padding-top: 1rem">
      <div class="tinySpacer"></div>
      <div>Welcome Back {{ username }}!</div>
      <div class="tinySpacer"></div>
      {{ userId }}
      <b-button
        v-b-tooltip.hover
        title="copy invite string"
        size="sm"
        style="
          background: #422c58;
          color: #dfdfdf;
          padding-right: 0.5rem;
          padding-bottom: 0.5rem;
        "
        @click="copy()"
      >
        <b-iconstack shift-h="-3.5"
          ><b-icon-person></b-icon-person><b-icon-files></b-icon-files
        ></b-iconstack>
      </b-button>
      <b-button
        v-if="adventureInvites.length > 0"
        v-b-modal="'accept-adventure'"
        style="
          background: none;
          border: none;
          height: 30px;
          width: 30px;
          box-shadow: none;
        "
      >
        <b-icon-circle-fill scale="1.5" style="color: #c15be6; z-index: 4">
        </b-icon-circle-fill>
        <div style="position: relative; bottom: 25px; left: 5px; z-index: 5">
          {{ adventureInvites.length }}
        </div>
      </b-button>
      <b-modal
        v-if="adventureInvites.length > 0"
        id="accept-adventure"
        ref="accept"
        ><div>
          You Have been invited to join:
          {{ adventureInvites[0].adventureId }}! This gives your GM full control
          over your character's information. If you accept, select the character
          you would like to send and hit YES, otherwise, hit NO.
        </div>
        <b-form-select
          v-model="selected"
          :options="dropdownOptions"
        ></b-form-select>
        <template #modal-footer>
          <b-button
            v-if="selected"
            @click="acceptInvite(selected, adventureInvites[0].id)"
            >YES</b-button
          >
          <b-button @click="rejectInvite(adventureInvites[0].id)">NO</b-button>
        </template>
      </b-modal>
      <div class="growSpacer"></div>
      <b-button
        v-if="!emailcheck"
        v-b-modal="'Email-Confirmation'"
        style="
          background: none;
          border: none;
          height: 30px;
          width: 30px;
          box-shadow: none;
        "
      >
        <b-icon-circle-fill
          scale="1.5"
          style="color: #c15be6; z-index: 4"
        ></b-icon-circle-fill>
        <div style="position: relative; bottom: 25px; left: 5px; z-index: 5">
          E
        </div>
      </b-button>
      <b-modal id="Email-Confirmation" ref="accept">
        <div>Enter your Email for Confirmation below:</div>
        <b-form-input
          v-model="email"
          placeholder="Enter your Email"
          style="background: #f1eef1; border: 2px solid #422c58"
        ></b-form-input>
        <template #modal-footer>
          <b-button size="lg" style="background: #422c58" @click="acceptEmail"
            >Save Email</b-button
          >
        </template>
      </b-modal>
      <div class="tinySpacer"></div>
      <b-button
        style="background: none; border: none; color: black"
        @click="logout()"
        >Logout</b-button
      >
      <div class="tinySpacer"></div>
    </div>
    <div style="font-size: 24px">My Characters</div>
    <hr style="color: #422c58; border: solid 1px" />
    <div
      style="
        display: flex;
        flex-direction: row;
        width: 100%;
        flex-wrap: wrap;
        padding-left: 10px;
      "
    >
      <div v-for="character in characters" :key="character.characterId">
        <div style="display: flex; flex-direction: row">
          <CharacterNav
            :id="character.characterId"
            :name="character.name"
            style="margin-bottom: 10px"
          />
          <div class="tinySpacer"></div>
        </div>
      </div>
      <div class="bubble">
        <div class="growSpacer"></div>
        <b-button style="background: none; border: none" @click="addCharacter"
          ><b-icon-plus scale="8"></b-icon-plus
        ></b-button>
        <div class="growSpacer"></div>
      </div>
      <div class="tinySpacer"></div>
    </div>

    <div style="font-size: 24px">My Adventures</div>

    <b-modal id="remove" ref="remove" title="Remove An Adventure">
      <p class="my-4">Select an adventure to remove...</p>
      <b-form-select
        v-model="adventureToRemove"
        :options="adventureNames"
      ></b-form-select>
      <template #modal-footer>
        <b-button @click="removeAdventure">Remove</b-button>
      </template>
    </b-modal>
    <hr style="color: #422c58; border: solid 1px" />
    <div
      style="
        display: flex;
        flex-direction: row;
        width: 100%;
        flex-wrap: wrap;
        padding-left: 10px;
      "
    >
      <div v-for="adventure in adventures" :key="adventure.adventureId">
        <div style="display: flex; flex-direction: row">
          <AdventureNav
            :id="adventure.adventureId"
            :name="adventure.name"
            style="margin-bottom: 10px"
          ></AdventureNav>
          <div class="tinySpacer"></div>
        </div>
      </div>
      <div v-b-tooltip.hover class="bubble" title="COMING SOON!">
        <div class="growSpacer"></div>
        <b-button
          style="color: #dfdfdf; background: #422c58; border: none"
          @click="addAdventure"
          ><b-icon-plus scale="8"></b-icon-plus
        ></b-button>
        <div class="growSpacer"></div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/store/store";
import CharacterNav from "@/components/Select/CharacterNav";
import AdventureNav from "@/components/Select/AdventureNav";
import { deleteToken } from "@/common/authentication/auth";
import {
  removeInvite,
  addCharAdvPair,
  deleteAdventure,
  postCharacterColor,
  postAdventure,
} from "@/common/adventure/adventure";
import {
  getAllCharacters,
  addNewCharacter,
} from "@/common/authentication/character";
import { addEmail } from "@/common/authentication/auth";
import { getAllAdventures, getAllInvites } from "@/common/adventure/adventure";
import { mapState } from "vuex";
import { getInvite } from "@/common/adventure/adventureInvite";
import characters from "@/store/adventure/characters";
//import { mapState } from "vuex";

export default {
  name: "CharacterSelect",
  components: { CharacterNav, AdventureNav },
  data: function () {
    return {
      adventurefeatureToggle: true,
      selected: 0,
      email: undefined,
      emailcheck: this.$store.getters["email"],
      adventureToRemove: undefined,
      loading: true,
      dropdownOptions: [],
    };
  },
  store,
  computed: {
    characters() {
      return this.$store.getters["characters"];
    },
    username() {
      return this.$store.getters["username"];
    },
    userId() {
      return this.$store.getters["userId"];
    },
    adventures() {
      return this.$store.getters["adventures"];
    },
    adventureInvites() {
      return this.$store.getters["invites"];
    },
    adventureNames() {
      let temp = this.$store.getters["adventures"];
      const array = [];
      if (!temp) {
        return array;
      }
      for (let ads of temp) {
        array.push(ads.name);
      }
      return array;
    },
  },
  created: function () {
    this.getCharacters();
    this.getAdventures();
    this.getInvites();
  },
  methods: {
    setDropdownOptions: function () {
      let ret = [];
      for (let c of this.characters) {
        ret.push({ value: c.characterId, text: c.name });
      }
      this.dropdownOptions = ret;
    },
    copy: function () {
      navigator.clipboard.writeText(this.userId);
      alert("Copied your invite id");
    },
    addCharacter: async function () {
      await addNewCharacter().then((response) => {
        if (response.data !== null) {
          const route = "/character/" + response.data.characterId;
          this.$router.push(route);
        }
      });
    },
    acceptInvite: function (characterId, id) {
      this.$store.dispatch("acceptInvite", {
        id: id,
        character_id: parseInt(characterId),
      });
      this.$refs["accept"].hide();
    },
    acceptEmail: async function () {
      const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      const email = this.email;
      if (re.test(String(email).toLowerCase())) {
        addEmail(this.username, email).then(() => {
          this.$store.commit("setEmail", this.email);
        });
      } else {
        alert("Invalid Email");
      }
    },
    rejectInvite: function (id) {
      this.$store.dispatch("declineInvite", id);
      this.$refs["accept"].hide();
    },
    addAdventure: function () {
      if (this.adventurefeatureToggle) {
        postAdventure();
      }
    },
    removeAdventure: function () {
      const arr = Array.from(this.$store.getters["adventures"]);
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].name === this.adventureToRemove) {
          deleteAdventure(arr[i].adventure_id).then(() => {
            arr.splice(i, 1);
            this.$store.commit("setAdventures", arr);
          });
        }
      }
      this.$refs["remove"].hide();
    },
    async getCharacters() {
      await getAllCharacters().then((response) => {
        this.$store.commit("setCharacters", response.data);
        this.loading = false;
        this.setDropdownOptions();
      });
    },
    async getAdventures() {
      getAllAdventures().then((response) => {
        this.$store.commit("setAdventures", response.data);
      });
    },
    async getInvites() {
      await getInvite().then((response) => {
        this.$store.commit("setInvites", response.data);
      });
    },
    logout() {
      deleteToken();
      this.$router.push("/login");
    },
  },
};
</script>

<style>
div.bubble {
  display: flex;
  flex-direction: column;
  height: 200px;
  width: 200px;
  border-radius: 20px;
  background: #422c58;
  color: #dfdfdf;
}
div.growSpacer {
  height: 10px;
  width: 10px;
  flex-grow: 1;
}
div.tinySpacer {
  width: 10px;
  height: 10px;
}
</style>
